
// import React from "react";
// import { useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import { z } from "zod";
// import { zodResolver } from "@hookform/resolvers/zod";
// import { ArrowLeft, Save } from "lucide-react";
// import Layout from "components/ui/Layout";
// import { useCreateOffer } from "features/offer/hooks/useOfferMutations";

// const offerSchema = z
//     .object({
//         title: z.string().min(3, "Title is required"),
//         code: z
//             .string()
//             .min(3, "Offer code is required")
//             .transform((val) => val.trim().toUpperCase()),
//         discountType: z.enum(["percentage", "fixed"]),
//         discountValue: z.number().min(1, "Discount value must be at least 1"),
//         minOrderValue: z.number().min(0, "Cannot be negative"),
//         maxDiscountValue: z.number().min(0, "Cannot be negative"),
//         startDate: z.string().min(1, "Start date is required"),
//         endDate: z.string().min(1, "End date is required"),
//         conditions: z.string().optional(),
//         autoApply: z.boolean(),
//         isDraft: z.boolean(),
//         appliesTo: z.enum(["services", "foodItems"]),
//     })
//     .refine((data) => new Date(data.endDate) > new Date(data.startDate), {
//         message: "End date must be after start date",
//         path: ["endDate"],
//     })
//     .refine(
//         (data) => !(data.discountType === "percentage" && data.discountValue > 100),
//         {
//             message: "Percentage discount cannot exceed 100",
//             path: ["discountValue"],
//         }
//     );

// const AddOfferPage = () => {
//     const navigate = useNavigate();
//     const { mutate: createOffer, isPending } = useCreateOffer();

//     const {
//         register,
//         handleSubmit,
//         reset,
//         formState: { errors },
//     } = useForm({
//         resolver: zodResolver(offerSchema),
//         defaultValues: {
//             title: "",
//             code: "",
//             discountType: "percentage",
//             discountValue: 0,
//             minOrderValue: 0,
//             maxDiscountValue: 0,
//             startDate: "",
//             endDate: "",
//             conditions: "",
//             autoApply: false,
//             isDraft: false,
//             appliesTo: "foodItems",
//         },
//     });

//     const onSubmit = (data) => {
//         const { appliesTo, ...rest } = data;

//         const payload = {
//             ...rest,
//             discountValue: Number(data.discountValue),
//             minOrderValue: Number(data.minOrderValue),
//             maxDiscountValue: Number(data.maxDiscountValue),
//             startDate: new Date(data.startDate).toISOString(),
//             endDate: new Date(data.endDate).toISOString(),
//         };

//         if (appliesTo === "services") {
//             payload.applicableServices = "all";
//         } else {
//             payload.applicableFoodItems = "all";
//         }

//         createOffer(payload, {
//             onSuccess: () => {
//                 reset();
//                 navigate('/offer');
//             },
//         });
//     };

//     return (
//         <Layout>
//             <div className="min-h-screen bg-background">
//                 {/* Fixed Header */}
//                 <div className="sticky top-0 z-10 bg-card border-b border-border">
//                     <div className="px-6 py-4">
//                         <div className="flex items-center justify-between">
//                             <div className="flex items-center gap-4">
//                                 <button
//                                     onClick={() => navigate('/offer')}
//                                     className="p-2 text-muted-foreground hover:text-foreground hover:bg-accent rounded transition-colors"
//                                     title="Back to Offers list"
//                                 >
//                                     <ArrowLeft size={20} />
//                                 </button>
//                                 <div>
//                                     <h3 className="text-lg font-semibold text-foreground">Add New Offer</h3>
//                                     <p className="text-sm text-muted-foreground">Create a new promotional offer</p>
//                                 </div>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <button
//                                     type="button"
//                                     onClick={() => navigate('/offer')}
//                                     className="px-4 py-2 text-sm border border-border text-foreground bg-card hover:bg-accent rounded-md transition-colors"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     form="offer-form"
//                                     disabled={isPending}
//                                     className="flex items-center gap-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50"
//                                 >
//                                     <Save size={16} />
//                                     {isPending ? 'Saving...' : 'Save Offer'}
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Main Content */}
//                 <div className="p-6">
//                     <div className="max-w-4xl mx-auto">
//                         <form id="offer-form" onSubmit={handleSubmit(onSubmit)}>
//                             <div className="bg-card border border-border rounded-lg p-6 space-y-5">
//                                 {/* Title */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-foreground mb-1">
//                                         Title <span className="text-destructive">*</span>
//                                     </label>
//                                     <input
//                                         {...register("title")}
//                                         className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                                         placeholder="Enter offer title"
//                                     />
//                                     {errors.title && (
//                                         <p className="text-destructive text-xs mt-1">{errors.title.message}</p>
//                                     )}
//                                 </div>

//                                 {/* Offer Code */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-foreground mb-1">
//                                         Offer Code <span className="text-destructive">*</span>
//                                     </label>
//                                    <input
//     {...register("code")}
//     className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent uppercase"
//     placeholder="NEWYEAR20"
//     onInput={(e) => {
//         e.target.value = e.target.value.replace(/\s/g, "");
//     }}
// />
//                                     {errors.code && (
//                                         <p className="text-destructive text-xs mt-1">{errors.code.message}</p>
//                                     )}
//                                 </div>

//                                 {/* Discount Type */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-foreground mb-1">
//                                         Discount Type <span className="text-destructive">*</span>
//                                     </label>
//                                     <select
//                                         {...register("discountType")}
//                                         className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                     >
//                                         <option value="percentage">Percentage (%)</option>
//                                         <option value="fixed">Fixed Amount</option>
//                                     </select>
//                                 </div>

//                                 {/* Applies To */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-foreground mb-1">
//                                         Applies To <span className="text-destructive">*</span>
//                                     </label>
//                                     <select
//                                         {...register("appliesTo")}
//                                         className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                     >
//                                         <option value="foodItems">All Food Items</option>
//                                         <option value="services">All Services</option>
//                                     </select>
//                                     {errors.appliesTo && (
//                                         <p className="text-destructive text-xs mt-1">{errors.appliesTo.message}</p>
//                                     )}
//                                 </div>

//                                 {/* Values grid */}
//                                 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-foreground mb-1">
//                                             Discount Value <span className="text-destructive">*</span>
//                                         </label>
//                                         <input
//                                             type="number"
//                                             {...register("discountValue", { valueAsNumber: true })}
//                                             className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                             placeholder="20"
//                                         />
//                                         {errors.discountValue && (
//                                             <p className="text-destructive text-xs mt-1">{errors.discountValue.message}</p>
//                                         )}
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-foreground mb-1">
//                                             Minimum Order Value
//                                         </label>
//                                         <input
//                                             type="number"
//                                             {...register("minOrderValue", { valueAsNumber: true })}
//                                             className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                             placeholder="500"
//                                         />
//                                         {errors.minOrderValue && (
//                                             <p className="text-destructive text-xs mt-1">{errors.minOrderValue.message}</p>
//                                         )}
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-foreground mb-1">
//                                             Maximum Discount Value
//                                         </label>
//                                         <input
//                                             type="number"
//                                             {...register("maxDiscountValue", { valueAsNumber: true })}
//                                             className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                             placeholder="200"
//                                         />
//                                         {errors.maxDiscountValue && (
//                                             <p className="text-destructive text-xs mt-1">{errors.maxDiscountValue.message}</p>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Dates */}
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                                     <div>
//                                         <label className="block text-sm font-medium text-foreground mb-1">
//                                             Start Date <span className="text-destructive">*</span>
//                                         </label>
//                                         <input
//                                             type="datetime-local"
//                                             {...register("startDate")}
//                                             className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                         />
//                                         {errors.startDate && (
//                                             <p className="text-destructive text-xs mt-1">{errors.startDate.message}</p>
//                                         )}
//                                     </div>

//                                     <div>
//                                         <label className="block text-sm font-medium text-foreground mb-1">
//                                             End Date <span className="text-destructive">*</span>
//                                         </label>
//                                         <input
//                                             type="datetime-local"
//                                             {...register("endDate")}
//                                             className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
//                                         />
//                                         {errors.endDate && (
//                                             <p className="text-destructive text-xs mt-1">{errors.endDate.message}</p>
//                                         )}
//                                     </div>
//                                 </div>

//                                 {/* Conditions */}
//                                 <div>
//                                     <label className="block text-sm font-medium text-foreground mb-1">
//                                         Description
//                                     </label>
//                                     <textarea
//                                         {...register("conditions")}
//                                         className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 h-20 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
//                                         placeholder="Valid for online payments only"
//                                     />
//                                 </div>

//                                 {/* Checkboxes */}
//                                 {/* <div className="space-y-3">
//                                     <div className="flex items-center gap-2">
//                                         <input
//                                             type="checkbox"
//                                             {...register("autoApply")}
//                                             className='mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'
//                                         />
//                                         <span className="text-sm text-foreground">Auto Apply</span>
//                                     </div>

//                                     <div className="flex items-center gap-2">
//                                         <input
//                                             type="checkbox"
//                                             {...register("isDraft")}
//                                             className='mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'
//                                         />
//                                         <span className="text-sm text-foreground">Save as Draft</span>
//                                     </div>
//                                 </div> */}
//                             </div>
//                         </form>
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     );
// };

// export default AddOfferPage;








import React from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { ArrowLeft, Save } from "lucide-react";
import Layout from "components/ui/Layout";
import { useCreateOffer } from "features/offer/hooks/useOfferMutations";

const offerSchema = z
    .object({
        title: z.string().min(3, "Title is required"),
        code: z
            .string()
            .min(3, "Offer code is required")
            .transform((val) => val.trim().toUpperCase()),
        discountType: z.enum(["percentage", "fixed"]),
        discountValue: z.number().min(1, "Discount value must be at least 1"),
        minOrderValue: z.number().min(0, "Cannot be negative"),
        maxDiscountValue: z.number().min(0, "Cannot be negative"),
        startDate: z.string().min(1, "Start date is required"),
        endDate: z.string().min(1, "End date is required"),
        conditions: z.string().optional(),
        autoApply: z.boolean(),
        isDraft: z.boolean(),
        appliesTo: z.enum(["services", "foodItems"]),
    })
    .refine((data) => new Date(data.endDate) > new Date(data.startDate), {
        message: "End date must be after start date",
        path: ["endDate"],
    })
    .refine(
        (data) => !(data.discountType === "percentage" && data.discountValue > 100),
        {
            message: "Percentage discount cannot exceed 100",
            path: ["discountValue"],
        }
    );


    // Formats a Date object into the "YYYY-MM-DDTHH:mm" string
// required by <input type="datetime-local"> min/max attributes.
const toDatetimeLocalString = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

const AddOfferPage = () => {
    const navigate = useNavigate();
    const { mutate: createOffer, isPending } = useCreateOffer();

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(offerSchema),
        defaultValues: {
            title: "",
            code: "",
            discountType: "percentage",
            discountValue: 0,
            minOrderValue: 0,
            maxDiscountValue: 0,
            startDate: "",
            endDate: "",
            conditions: "",
            autoApply: false,
            isDraft: false,
            appliesTo: "foodItems",
        },
    });

    const startDateValue = watch("startDate");

// Minimum selectable value for Start Date = right now
const minStartDate = toDatetimeLocalString(new Date());

// Minimum selectable value for End Date = whatever Start Date currently is,
// falling back to "now" if Start Date hasn't been picked yet.
const minEndDate = startDateValue || minStartDate;

    const onSubmit = (data) => {
        const { appliesTo, ...rest } = data;

        const payload = {
            ...rest,
            discountValue: Number(data.discountValue),
            minOrderValue: Number(data.minOrderValue),
            maxDiscountValue: Number(data.maxDiscountValue),
            startDate: new Date(data.startDate).toISOString(),
            endDate: new Date(data.endDate).toISOString(),
        };

        if (appliesTo === "services") {
            payload.applicableServices = "all";
        } else {
            payload.applicableFoodItems = "all";
        }

        createOffer(payload, {
            onSuccess: () => {
                reset();
                navigate('/offer');
            },
        });
    };

    return (
        <Layout>
            <div className="min-h-screen bg-background">
                {/* Fixed Header */}
                <div className="sticky top-0 z-10 bg-card border-b border-border">
                    <div className="px-6 py-4">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-4">
                                <button
                                    onClick={() => navigate('/offer')}
                                    className="p-2 text-muted-foreground hover:text-foreground hover:bg-accent rounded transition-colors"
                                    title="Back to Offers list"
                                >
                                    <ArrowLeft size={20} />
                                </button>
                                <div>
                                    <h3 className="text-lg font-semibold text-foreground">Add New Offer</h3>
                                    <p className="text-sm text-muted-foreground">Create a new promotional offer</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <button
                                    type="button"
                                    onClick={() => navigate('/offer')}
                                    className="px-4 py-2 text-sm border border-border text-foreground bg-card hover:bg-accent rounded-md transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    form="offer-form"
                                    disabled={isPending}
                                    className="flex items-center gap-2 px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50"
                                >
                                    <Save size={16} />
                                    {isPending ? 'Saving...' : 'Save Offer'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className="p-6">
                    <div className="max-w-4xl mx-auto">
                        <form id="offer-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="bg-card border border-border rounded-lg p-6 space-y-5">
                                {/* Title */}
                                <div>
                                    <label className="block text-sm font-medium text-foreground mb-1">
                                        Title <span className="text-destructive">*</span>
                                    </label>
                                    <input
                                        {...register("title")}
                                        className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                                        placeholder="Enter offer title"
                                    />
                                    {errors.title && (
                                        <p className="text-destructive text-xs mt-1">{errors.title.message}</p>
                                    )}
                                </div>

                                {/* Offer Code */}
                                <div>
                                    <label className="block text-sm font-medium text-foreground mb-1">
                                        Offer Code <span className="text-destructive">*</span>
                                    </label>
                                   <input
    {...register("code")}
    className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent uppercase"
    placeholder="NEWYEAR20"
    onInput={(e) => {
        e.target.value = e.target.value.replace(/\s/g, "");
    }}
/>
                                    {errors.code && (
                                        <p className="text-destructive text-xs mt-1">{errors.code.message}</p>
                                    )}
                                </div>

                                {/* Discount Type */}
                                <div>
                                    <label className="block text-sm font-medium text-foreground mb-1">
                                        Discount Type <span className="text-destructive">*</span>
                                    </label>
                                    <select
                                        {...register("discountType")}
                                        className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                    >
                                        <option value="percentage">Percentage (%)</option>
                                        <option value="fixed">Fixed Amount</option>
                                    </select>
                                </div>

                                {/* Applies To */}
                                <div>
                                    <label className="block text-sm font-medium text-foreground mb-1">
                                        Applies To <span className="text-destructive">*</span>
                                    </label>
                                    <select
                                        {...register("appliesTo")}
                                        className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                    >
                                        <option value="foodItems">All Food Items</option>
                                        <option value="services">All Services</option>
                                    </select>
                                    {errors.appliesTo && (
                                        <p className="text-destructive text-xs mt-1">{errors.appliesTo.message}</p>
                                    )}
                                </div>

                                {/* Values grid */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-foreground mb-1">
                                            Discount Value <span className="text-destructive">*</span>
                                        </label>
                                        <input
                                            type="number"
                                            {...register("discountValue", { valueAsNumber: true })}
                                            className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                            placeholder="20"
                                        />
                                        {errors.discountValue && (
                                            <p className="text-destructive text-xs mt-1">{errors.discountValue.message}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-foreground mb-1">
                                            Minimum Order Value
                                        </label>
                                        <input
                                            type="number"
                                            {...register("minOrderValue", { valueAsNumber: true })}
                                            className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                            placeholder="500"
                                        />
                                        {errors.minOrderValue && (
                                            <p className="text-destructive text-xs mt-1">{errors.minOrderValue.message}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-foreground mb-1">
                                            Maximum Discount Value
                                        </label>
                                        <input
                                            type="number"
                                            {...register("maxDiscountValue", { valueAsNumber: true })}
                                            className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                            placeholder="200"
                                        />
                                        {errors.maxDiscountValue && (
                                            <p className="text-destructive text-xs mt-1">{errors.maxDiscountValue.message}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Dates */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-foreground mb-1">
                                            Start Date <span className="text-destructive">*</span>
                                        </label>
                                        <input
                                            type="datetime-local"
                                            min={minStartDate}
                                            {...register("startDate")}
                                            className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                        />
                                        {errors.startDate && (
                                            <p className="text-destructive text-xs mt-1">{errors.startDate.message}</p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-medium text-foreground mb-1">
                                            End Date <span className="text-destructive">*</span>
                                        </label>
                                        <input
                                            type="datetime-local"
                                            min={minEndDate}
                                            {...register("endDate")}
                                            className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 focus:ring-2 focus:ring-primary focus:border-transparent"
                                        />
                                        {errors.endDate && (
                                            <p className="text-destructive text-xs mt-1">{errors.endDate.message}</p>
                                        )}
                                    </div>
                                </div>

                                {/* Conditions */}
                                <div>
                                    <label className="block text-sm font-medium text-foreground mb-1">
                                        Description
                                    </label>
                                    <textarea
                                        {...register("conditions")}
                                        className="w-full bg-input border border-border text-foreground rounded-md px-3 py-2 h-20 placeholder-muted-foreground focus:ring-2 focus:ring-primary focus:border-transparent"
                                        placeholder="Valid for online payments only"
                                    />
                                </div>

                                {/* Checkboxes */}
                                {/* <div className="space-y-3">
                                    <div className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            {...register("autoApply")}
                                            className='mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'
                                        />
                                        <span className="text-sm text-foreground">Auto Apply</span>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <input
                                            type="checkbox"
                                            {...register("isDraft")}
                                            className='mt-1 !bg-none checked:!bg-blue-500 !border-none focus:!outline-none'
                                        />
                                        <span className="text-sm text-foreground">Save as Draft</span>
                                    </div>
                                </div> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AddOfferPage;